import ContentBlock from "@/components/content-block/index";
import dynamicLocalization from "@/mixins/dynamic-localization";

export default {
  props: {
    sections: {
      type: Array,
      required: true,
    },
    title: {
      type: Object,
      required: false,
      default: null,
    },
    heroImage: {
      type: String,
      required: false,
    },
  },
  components: { ContentBlock },
  mixins: [dynamicLocalization],
};
